import React from "react";
import { Grid } from "@mui/material";

// import ellieLogo from "../../../src/assets/images/avatar/cclogos/ellie-logo.svg";
import Image from "./Image";

export const Logo: React.FC = () => {
  return (
    <Grid container justifyContent="center">
      {/* <img src={ellieLogo} alt="logo" width={200} /> */}
      <Image
        src={"https://elliecare-public-images.s3.sa-east-1.amazonaws.com/cc-logos/ELLIE.svg"}
        alt="provider-logo"
        width="100px"
        height="100px"
        style={{ cursor: "pointer", borderRadius: "50%" }}
      />
    </Grid>
  );
};
